// Demo Mode - Mock backend for Figma Make preview
// Provides working authentication and data without requiring a real backend

export const DEMO_USERS = {
  admin: {
    _id: 'demo-admin-001',
    email: 'admin@test.com',
    password: 'Admin@123456',
    firstName: 'Admin',
    lastName: 'User',
    phone: '+919876543210',
    role: 'admin',
    gender: 'Male',
    dateOfBirth: '1990-01-01',
    religion: 'Hindu',
    caste: 'Brahmin',
    height: '5\'10"',
    maritalStatus: 'Never Married',
    education: 'Master\'s Degree',
    occupation: 'Software Engineer',
    income: '10-15 Lakhs',
    city: 'Mumbai',
    state: 'Maharashtra',
    country: 'India',
    profilePicture: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400',
    bio: 'Admin user with full system access',
    verified: true,
    premium: true,
    isEmailVerified: true,
    isPhoneVerified: true,
    profileCompleted: true,
    adminVerification: {
      status: 'approved',
      approvedAt: new Date().toISOString(),
      notes: 'Demo admin - auto approved'
    },
    credits: 0,
    profileBoostActive: false,
    boostMultiplier: 1,
    createdAt: new Date().toISOString()
  },
  marketing: {
    _id: 'demo-marketing-001',
    email: 'marketing@test.com',
    password: 'Marketing@123456',
    firstName: 'Marketing',
    lastName: 'User',
    phone: '+919876543211',
    role: 'marketing',
    gender: 'Female',
    dateOfBirth: '1992-05-15',
    religion: 'Hindu',
    caste: 'Kshatriya',
    height: '5\'6"',
    maritalStatus: 'Never Married',
    education: 'Bachelor\'s Degree',
    occupation: 'Marketing Manager',
    income: '8-10 Lakhs',
    city: 'Delhi',
    state: 'Delhi',
    country: 'India',
    profilePicture: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400',
    bio: 'Marketing user with coupon creation access',
    verified: true,
    premium: false,
    isEmailVerified: true,
    isPhoneVerified: true,
    profileCompleted: true,
    credits: 0,
    profileBoostActive: false,
    boostMultiplier: 1,
    marketingData: {
      commission: 50,
      totalEarnings: 5000,
      pendingEarnings: 2000,
      withdrawnEarnings: 3000,
      isActive: true,
      lastActive: new Date().toISOString(),
      referralCode: 'MARKET10'
    },
    createdAt: new Date().toISOString()
  },
  user: {
    _id: 'demo-user-001',
    email: 'user@test.com',
    password: 'User@123456',
    firstName: 'Premium',
    lastName: 'User',
    phone: '+919876543212',
    role: 'user',
    gender: 'Male',
    dateOfBirth: '1995-08-20',
    religion: 'Hindu',
    caste: 'Vaishya',
    height: '5\'9"',
    maritalStatus: 'Never Married',
    education: 'Bachelor\'s Degree',
    occupation: 'Software Developer',
    income: '6-8 Lakhs',
    city: 'Bangalore',
    state: 'Karnataka',
    country: 'India',
    profilePicture: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400',
    bio: 'Looking for a life partner who shares similar values and interests.',
    verified: true,
    premium: true,
    isEmailVerified: true,
    isPhoneVerified: true,
    profileCompleted: true,
    credits: 100,
    profileBoostActive: true,
    boostMultiplier: 10,
    boostExpiry: '2026-02-25T00:00:00.000Z',
    createdAt: new Date().toISOString()
  }
};

export const DEMO_PROFILES = [
  {
    _id: 'demo-profile-001',
    firstName: 'Priya',
    lastName: 'Sharma',
    age: 26,
    gender: 'Female',
    religion: 'Hindu',
    caste: 'Brahmin',
    height: '5\'4"',
    education: 'Masters in Computer Science',
    occupation: 'Software Engineer',
    income: '12-15 LPA',
    city: 'Pune',
    state: 'Maharashtra',
    profilePicture: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400',
    verified: true,
    premium: true,
    matchScore: 95
  },
  {
    _id: 'demo-profile-002',
    firstName: 'Rahul',
    lastName: 'Patel',
    age: 29,
    gender: 'Male',
    religion: 'Hindu',
    caste: 'General',
    height: '5\'11"',
    education: 'MBA',
    occupation: 'Business Analyst',
    income: '15-20 LPA',
    city: 'Ahmedabad',
    state: 'Gujarat',
    profilePicture: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400',
    verified: true,
    premium: false,
    matchScore: 88
  },
  {
    _id: 'demo-profile-003',
    firstName: 'Ananya',
    lastName: 'Reddy',
    age: 25,
    gender: 'Female',
    religion: 'Hindu',
    caste: 'General',
    height: '5\'3"',
    education: 'B.Tech',
    occupation: 'Data Scientist',
    income: '10-12 LPA',
    city: 'Hyderabad',
    state: 'Telangana',
    profilePicture: 'https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=400',
    verified: true,
    premium: true,
    matchScore: 92
  },
  {
    _id: 'demo-profile-004',
    firstName: 'Vikram',
    lastName: 'Singh',
    age: 31,
    gender: 'Male',
    religion: 'Sikh',
    caste: 'General',
    height: '6\'0"',
    education: 'CA',
    occupation: 'Chartered Accountant',
    income: '18-25 LPA',
    city: 'Chandigarh',
    state: 'Punjab',
    profilePicture: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400',
    verified: true,
    premium: true,
    matchScore: 85
  },
  {
    _id: 'demo-profile-005',
    firstName: 'Meera',
    lastName: 'Iyer',
    age: 27,
    gender: 'Female',
    religion: 'Hindu',
    caste: 'Brahmin',
    height: '5\'5"',
    education: 'MBBS',
    occupation: 'Doctor',
    income: '15-20 LPA',
    city: 'Chennai',
    state: 'Tamil Nadu',
    profilePicture: 'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=400',
    verified: true,
    premium: true,
    matchScore: 90
  }
];

export const DEMO_MESSAGES = [
  {
    _id: 'msg-001',
    senderId: 'demo-profile-001',
    senderName: 'Priya Sharma',
    message: 'Hi! I saw your profile and thought we might be a good match.',
    timestamp: new Date(Date.now() - 3600000).toISOString(),
    read: false
  },
  {
    _id: 'msg-002',
    senderId: 'demo-profile-003',
    senderName: 'Ananya Reddy',
    message: 'Hello! Would love to connect and chat.',
    timestamp: new Date(Date.now() - 7200000).toISOString(),
    read: true
  }
];

// Generate demo token
export const generateDemoToken = (user: any) => {
  const tokenData = {
    userId: user._id,
    email: user.email,
    role: user.role,
    demo: true,
    timestamp: Date.now()
  };
  return btoa(JSON.stringify(tokenData));
};

// Validate demo token
export const validateDemoToken = (token: string) => {
  try {
    const decoded = JSON.parse(atob(token));
    if (decoded.demo && decoded.userId) {
      // Find user by ID
      const user = Object.values(DEMO_USERS).find((u: any) => u._id === decoded.userId);
      return user || null;
    }
    return null;
  } catch (error) {
    return null;
  }
};

// Demo API responses
export const demoAPI = {
  // Authentication
  login: async (email: string, password: string) => {
    await new Promise(resolve => setTimeout(resolve, 500)); // Simulate network delay
    
    const user = Object.values(DEMO_USERS).find(
      (u: any) => u.email === email && u.password === password
    );
    
    if (user) {
      const { password: _, ...userWithoutPassword } = user as any;
      const token = generateDemoToken(user);
      
      return {
        success: true,
        data: {
          token,
          user: userWithoutPassword
        }
      };
    }
    
    return {
      success: false,
      message: 'Invalid credentials'
    };
  },

  // Truecaller Login
  truecallerLogin: async (truecallerData: {
    phone: string;
    firstName?: string;
    lastName?: string;
    email?: string;
  }) => {
    await new Promise(resolve => setTimeout(resolve, 500)); // Simulate network delay
    
    console.log('🎭 Demo Mode: Truecaller login with:', truecallerData);
    
    // Check if user exists by phone
    let user = Object.values(DEMO_USERS).find(
      (u: any) => u.phone === truecallerData.phone
    );
    
    if (user) {
      // Existing user - login
      console.log('✅ Demo Mode: Existing user found');
      const { password: _, ...userWithoutPassword } = user as any;
      const token = generateDemoToken(user);
      
      return {
        success: true,
        data: {
          token,
          user: userWithoutPassword
        }
      };
    } else {
      // New user - create account
      console.log('✅ Demo Mode: Creating new user from Truecaller');
      const newUser = {
        _id: `demo-truecaller-${Date.now()}`,
        email: truecallerData.email || `${truecallerData.phone}@truecaller.demo`,
        firstName: truecallerData.firstName || 'Truecaller',
        lastName: truecallerData.lastName || 'User',
        phone: truecallerData.phone,
        role: 'user' as const,
        gender: 'Male',
        dateOfBirth: '1990-01-01',
        religion: 'Hindu',
        caste: 'General',
        height: '5\'8"',
        maritalStatus: 'Never Married',
        education: 'Bachelor\'s Degree',
        occupation: 'Professional',
        income: '5-10 Lakhs',
        city: 'Mumbai',
        state: 'Maharashtra',
        country: 'India',
        profilePicture: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400',
        bio: 'New user registered via Truecaller',
        verified: true,
        premium: false,
        isEmailVerified: false,
        isPhoneVerified: true, // Truecaller verifies phone
        profileCompleted: false,
        credits: 0,
        profileBoostActive: false,
        boostMultiplier: 1,
        createdAt: new Date().toISOString()
      };
      
      const { password: _, ...userWithoutPassword } = newUser as any;
      const token = generateDemoToken(newUser);
      
      return {
        success: true,
        data: {
          token,
          user: userWithoutPassword
        }
      };
    }
  },

  register: async (userData: any) => {
    await new Promise(resolve => setTimeout(resolve, 500));
    
    // Check if user already exists
    const exists = Object.values(DEMO_USERS).some(
      (u: any) => u.email === userData.email
    );
    
    if (exists) {
      return {
        success: false,
        message: 'User already exists'
      };
    }
    
    // Create new demo user
    const newUser = {
      _id: `demo-user-${Date.now()}`,
      ...userData,
      role: userData.role || 'user',
      verified: false,
      premium: false,
      createdAt: new Date().toISOString()
    };
    
    const { password: _, ...userWithoutPassword } = newUser;
    const token = generateDemoToken(newUser);
    
    return {
      success: true,
      data: {
        token,
        user: userWithoutPassword
      }
    };
  },

  loadUser: async (token: string) => {
    await new Promise(resolve => setTimeout(resolve, 300));
    
    const user = validateDemoToken(token);
    
    if (user) {
      const { password: _, ...userWithoutPassword } = user as any;
      return {
        success: true,
        data: {
          user: userWithoutPassword
        }
      };
    }
    
    return {
      success: false,
      message: 'Invalid token'
    };
  },

  // Profiles
  getProfiles: async () => {
    await new Promise(resolve => setTimeout(resolve, 400));
    
    return {
      success: true,
      data: DEMO_PROFILES
    };
  },

  getProfile: async (id: string) => {
    await new Promise(resolve => setTimeout(resolve, 300));
    
    const profile = DEMO_PROFILES.find(p => p._id === id);
    
    if (profile) {
      return {
        success: true,
        data: profile
      };
    }
    
    return {
      success: false,
      message: 'Profile not found'
    };
  },

  // Messages
  getMessages: async () => {
    await new Promise(resolve => setTimeout(resolve, 300));
    
    return {
      success: true,
      data: DEMO_MESSAGES
    };
  },

  sendMessage: async (recipientId: string, message: string) => {
    await new Promise(resolve => setTimeout(resolve, 400));
    
    const newMessage = {
      _id: `msg-${Date.now()}`,
      recipientId,
      message,
      timestamp: new Date().toISOString(),
      read: false
    };
    
    return {
      success: true,
      data: newMessage
    };
  }
};

// Check if we should use demo mode
export const shouldUseDemoMode = () => {
  // Priority 1: Check explicit VITE_DEMO_MODE setting
  try {
    if (typeof import.meta !== 'undefined' && import.meta.env && typeof import.meta.env.VITE_DEMO_MODE !== 'undefined') {
      const demoMode = import.meta.env.VITE_DEMO_MODE;
      
      // Handle string values from .env
      if (demoMode === 'true' || demoMode === true) {
        console.log('🎭 Demo Mode: FORCE ENABLED via VITE_DEMO_MODE=true');
        return true;
      }
      if (demoMode === 'false' || demoMode === false) {
        if (import.meta.env.DEV) {
          console.log('✅ Demo Mode: FORCE DISABLED via VITE_DEMO_MODE=false');
        }
        return false;
      }
    }
  } catch (error) {
    // Silently handle error
  }

  // Priority 2: Check if in Figma Make environment
  const isFigmaMake = window.location.hostname.includes('figma.com') || 
                      window.location.hostname.includes('figma.site') ||
                      window.location.hostname.includes('figmaiframepreview') ||
                      window.location.hostname.includes('figma.engineering') ||
                      window.location.hostname.includes('esm.sh');
  
  // Priority 3: Check if we're in localhost (development mode)
  const isLocalhost = window.location.hostname === 'localhost' || 
                     window.location.hostname === '127.0.0.1';
  
  // Priority 4: Check if backend URL is configured
  let hasBackendUrl = false;
  try {
    if (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_BACKEND_URL) {
      hasBackendUrl = true;
    }
  } catch (error) {
    // Silently handle error
  }
  
  // Use demo mode if in Figma Make
  if (isFigmaMake) {
    console.log('🎭 Demo Mode: Detected Figma Make environment');
    return true;
  }
  
  // In localhost, only use demo mode if no backend URL is configured
  if (isLocalhost && !hasBackendUrl) {
    console.log('🎭 Demo Mode: Localhost without backend URL');
    return true;
  }
  
  // Default: Demo mode disabled
  console.log('✅ Demo Mode: Disabled (backend connected)');
  return false;
};

// Demo mode info for display
export const getDemoModeInfo = () => {
  return {
    enabled: shouldUseDemoMode(),
    testAccounts: [
      { email: 'admin@test.com', password: 'Admin@123456', role: 'Admin' },
      { email: 'marketing@test.com', password: 'Marketing@123456', role: 'Marketing' },
      { email: 'user@test.com', password: 'User@123456', role: 'User' }
    ]
  };
};